/**
 * AUTO-GENERATED from generate-icons script 🤖 - DO NOT EDIT!
 */

import dynamicHydrate from '@bluheadless/ui-logic/src/dynamic-hydration/dynamic-hydrate'
import EmptyIcon from '../../icon/empty'

export * from './project-related-icons'
export const AbwSquareIcon = dynamicHydrate(() => import('./abw-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const AbwSquareIconSvg = dynamicHydrate(() => import('./abw-square-icon').then((mod) => mod.AbwSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const AfgSquareIcon = dynamicHydrate(() => import('./afg-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const AfgSquareIconSvg = dynamicHydrate(() => import('./afg-square-icon').then((mod) => mod.AfgSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const AgoSquareIcon = dynamicHydrate(() => import('./ago-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const AgoSquareIconSvg = dynamicHydrate(() => import('./ago-square-icon').then((mod) => mod.AgoSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const AiaSquareIcon = dynamicHydrate(() => import('./aia-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const AiaSquareIconSvg = dynamicHydrate(() => import('./aia-square-icon').then((mod) => mod.AiaSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const AlaSquareIcon = dynamicHydrate(() => import('./ala-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const AlaSquareIconSvg = dynamicHydrate(() => import('./ala-square-icon').then((mod) => mod.AlaSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const AlbSquareIcon = dynamicHydrate(() => import('./alb-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const AlbSquareIconSvg = dynamicHydrate(() => import('./alb-square-icon').then((mod) => mod.AlbSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const AndSquareIcon = dynamicHydrate(() => import('./and-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const AndSquareIconSvg = dynamicHydrate(() => import('./and-square-icon').then((mod) => mod.AndSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const AntSquareIcon = dynamicHydrate(() => import('./ant-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const AntSquareIconSvg = dynamicHydrate(() => import('./ant-square-icon').then((mod) => mod.AntSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const AreSquareIcon = dynamicHydrate(() => import('./are-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const AreSquareIconSvg = dynamicHydrate(() => import('./are-square-icon').then((mod) => mod.AreSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const ArgSquareIcon = dynamicHydrate(() => import('./arg-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const ArgSquareIconSvg = dynamicHydrate(() => import('./arg-square-icon').then((mod) => mod.ArgSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const ArmSquareIcon = dynamicHydrate(() => import('./arm-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const ArmSquareIconSvg = dynamicHydrate(() => import('./arm-square-icon').then((mod) => mod.ArmSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const AseSquareIcon = dynamicHydrate(() => import('./ase-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const AseSquareIconSvg = dynamicHydrate(() => import('./ase-square-icon').then((mod) => mod.AseSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const AsmSquareIcon = dynamicHydrate(() => import('./asm-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const AsmSquareIconSvg = dynamicHydrate(() => import('./asm-square-icon').then((mod) => mod.AsmSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const AtaSquareIcon = dynamicHydrate(() => import('./ata-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const AtaSquareIconSvg = dynamicHydrate(() => import('./ata-square-icon').then((mod) => mod.AtaSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const AtfSquareIcon = dynamicHydrate(() => import('./atf-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const AtfSquareIconSvg = dynamicHydrate(() => import('./atf-square-icon').then((mod) => mod.AtfSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const AtgSquareIcon = dynamicHydrate(() => import('./atg-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const AtgSquareIconSvg = dynamicHydrate(() => import('./atg-square-icon').then((mod) => mod.AtgSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const AusSquareIcon = dynamicHydrate(() => import('./aus-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const AusSquareIconSvg = dynamicHydrate(() => import('./aus-square-icon').then((mod) => mod.AusSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const AutSquareIcon = dynamicHydrate(() => import('./aut-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const AutSquareIconSvg = dynamicHydrate(() => import('./aut-square-icon').then((mod) => mod.AutSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const AzeSquareIcon = dynamicHydrate(() => import('./aze-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const AzeSquareIconSvg = dynamicHydrate(() => import('./aze-square-icon').then((mod) => mod.AzeSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const BdiSquareIcon = dynamicHydrate(() => import('./bdi-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const BdiSquareIconSvg = dynamicHydrate(() => import('./bdi-square-icon').then((mod) => mod.BdiSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const BelSquareIcon = dynamicHydrate(() => import('./bel-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const BelSquareIconSvg = dynamicHydrate(() => import('./bel-square-icon').then((mod) => mod.BelSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const BenSquareIcon = dynamicHydrate(() => import('./ben-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const BenSquareIconSvg = dynamicHydrate(() => import('./ben-square-icon').then((mod) => mod.BenSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const BesSquareIcon = dynamicHydrate(() => import('./bes-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const BesSquareIconSvg = dynamicHydrate(() => import('./bes-square-icon').then((mod) => mod.BesSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const BfaSquareIcon = dynamicHydrate(() => import('./bfa-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const BfaSquareIconSvg = dynamicHydrate(() => import('./bfa-square-icon').then((mod) => mod.BfaSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const BgdSquareIcon = dynamicHydrate(() => import('./bgd-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const BgdSquareIconSvg = dynamicHydrate(() => import('./bgd-square-icon').then((mod) => mod.BgdSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const BgrSquareIcon = dynamicHydrate(() => import('./bgr-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const BgrSquareIconSvg = dynamicHydrate(() => import('./bgr-square-icon').then((mod) => mod.BgrSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const BhrSquareIcon = dynamicHydrate(() => import('./bhr-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const BhrSquareIconSvg = dynamicHydrate(() => import('./bhr-square-icon').then((mod) => mod.BhrSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const BhsSquareIcon = dynamicHydrate(() => import('./bhs-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const BhsSquareIconSvg = dynamicHydrate(() => import('./bhs-square-icon').then((mod) => mod.BhsSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const BihSquareIcon = dynamicHydrate(() => import('./bih-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const BihSquareIconSvg = dynamicHydrate(() => import('./bih-square-icon').then((mod) => mod.BihSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const BlmSquareIcon = dynamicHydrate(() => import('./blm-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const BlmSquareIconSvg = dynamicHydrate(() => import('./blm-square-icon').then((mod) => mod.BlmSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const BlrSquareIcon = dynamicHydrate(() => import('./blr-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const BlrSquareIconSvg = dynamicHydrate(() => import('./blr-square-icon').then((mod) => mod.BlrSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const BlzSquareIcon = dynamicHydrate(() => import('./blz-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const BlzSquareIconSvg = dynamicHydrate(() => import('./blz-square-icon').then((mod) => mod.BlzSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const BmuSquareIcon = dynamicHydrate(() => import('./bmu-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const BmuSquareIconSvg = dynamicHydrate(() => import('./bmu-square-icon').then((mod) => mod.BmuSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const BolSquareIcon = dynamicHydrate(() => import('./bol-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const BolSquareIconSvg = dynamicHydrate(() => import('./bol-square-icon').then((mod) => mod.BolSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const BraSquareIcon = dynamicHydrate(() => import('./bra-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const BraSquareIconSvg = dynamicHydrate(() => import('./bra-square-icon').then((mod) => mod.BraSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const BrbSquareIcon = dynamicHydrate(() => import('./brb-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const BrbSquareIconSvg = dynamicHydrate(() => import('./brb-square-icon').then((mod) => mod.BrbSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const BrnSquareIcon = dynamicHydrate(() => import('./brn-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const BrnSquareIconSvg = dynamicHydrate(() => import('./brn-square-icon').then((mod) => mod.BrnSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const BtnSquareIcon = dynamicHydrate(() => import('./btn-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const BtnSquareIconSvg = dynamicHydrate(() => import('./btn-square-icon').then((mod) => mod.BtnSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const BvtSquareIcon = dynamicHydrate(() => import('./bvt-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const BvtSquareIconSvg = dynamicHydrate(() => import('./bvt-square-icon').then((mod) => mod.BvtSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const BwaSquareIcon = dynamicHydrate(() => import('./bwa-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const BwaSquareIconSvg = dynamicHydrate(() => import('./bwa-square-icon').then((mod) => mod.BwaSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const CafSquareIcon = dynamicHydrate(() => import('./caf-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const CafSquareIconSvg = dynamicHydrate(() => import('./caf-square-icon').then((mod) => mod.CafSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const CanSquareIcon = dynamicHydrate(() => import('./can-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const CanSquareIconSvg = dynamicHydrate(() => import('./can-square-icon').then((mod) => mod.CanSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const CckSquareIcon = dynamicHydrate(() => import('./cck-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const CckSquareIconSvg = dynamicHydrate(() => import('./cck-square-icon').then((mod) => mod.CckSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const CheSquareIcon = dynamicHydrate(() => import('./che-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const CheSquareIconSvg = dynamicHydrate(() => import('./che-square-icon').then((mod) => mod.CheSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const ChlSquareIcon = dynamicHydrate(() => import('./chl-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const ChlSquareIconSvg = dynamicHydrate(() => import('./chl-square-icon').then((mod) => mod.ChlSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const ChnSquareIcon = dynamicHydrate(() => import('./chn-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const ChnSquareIconSvg = dynamicHydrate(() => import('./chn-square-icon').then((mod) => mod.ChnSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const CivSquareIcon = dynamicHydrate(() => import('./civ-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const CivSquareIconSvg = dynamicHydrate(() => import('./civ-square-icon').then((mod) => mod.CivSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const CmrSquareIcon = dynamicHydrate(() => import('./cmr-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const CmrSquareIconSvg = dynamicHydrate(() => import('./cmr-square-icon').then((mod) => mod.CmrSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const CodSquareIcon = dynamicHydrate(() => import('./cod-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const CodSquareIconSvg = dynamicHydrate(() => import('./cod-square-icon').then((mod) => mod.CodSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const CogSquareIcon = dynamicHydrate(() => import('./cog-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const CogSquareIconSvg = dynamicHydrate(() => import('./cog-square-icon').then((mod) => mod.CogSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const CokSquareIcon = dynamicHydrate(() => import('./cok-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const CokSquareIconSvg = dynamicHydrate(() => import('./cok-square-icon').then((mod) => mod.CokSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const ColSquareIcon = dynamicHydrate(() => import('./col-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const ColSquareIconSvg = dynamicHydrate(() => import('./col-square-icon').then((mod) => mod.ColSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const ComSquareIcon = dynamicHydrate(() => import('./com-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const ComSquareIconSvg = dynamicHydrate(() => import('./com-square-icon').then((mod) => mod.ComSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const CpvSquareIcon = dynamicHydrate(() => import('./cpv-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const CpvSquareIconSvg = dynamicHydrate(() => import('./cpv-square-icon').then((mod) => mod.CpvSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const CriSquareIcon = dynamicHydrate(() => import('./cri-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const CriSquareIconSvg = dynamicHydrate(() => import('./cri-square-icon').then((mod) => mod.CriSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const CubSquareIcon = dynamicHydrate(() => import('./cub-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const CubSquareIconSvg = dynamicHydrate(() => import('./cub-square-icon').then((mod) => mod.CubSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const CuwSquareIcon = dynamicHydrate(() => import('./cuw-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const CuwSquareIconSvg = dynamicHydrate(() => import('./cuw-square-icon').then((mod) => mod.CuwSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const CxrSquareIcon = dynamicHydrate(() => import('./cxr-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const CxrSquareIconSvg = dynamicHydrate(() => import('./cxr-square-icon').then((mod) => mod.CxrSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const CymSquareIcon = dynamicHydrate(() => import('./cym-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const CymSquareIconSvg = dynamicHydrate(() => import('./cym-square-icon').then((mod) => mod.CymSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const CypSquareIcon = dynamicHydrate(() => import('./cyp-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const CypSquareIconSvg = dynamicHydrate(() => import('./cyp-square-icon').then((mod) => mod.CypSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const CzeSquareIcon = dynamicHydrate(() => import('./cze-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const CzeSquareIconSvg = dynamicHydrate(() => import('./cze-square-icon').then((mod) => mod.CzeSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const DeuSquareIcon = dynamicHydrate(() => import('./deu-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const DeuSquareIconSvg = dynamicHydrate(() => import('./deu-square-icon').then((mod) => mod.DeuSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const DjiSquareIcon = dynamicHydrate(() => import('./dji-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const DjiSquareIconSvg = dynamicHydrate(() => import('./dji-square-icon').then((mod) => mod.DjiSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const DmaSquareIcon = dynamicHydrate(() => import('./dma-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const DmaSquareIconSvg = dynamicHydrate(() => import('./dma-square-icon').then((mod) => mod.DmaSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const DnkSquareIcon = dynamicHydrate(() => import('./dnk-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const DnkSquareIconSvg = dynamicHydrate(() => import('./dnk-square-icon').then((mod) => mod.DnkSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const DomSquareIcon = dynamicHydrate(() => import('./dom-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const DomSquareIconSvg = dynamicHydrate(() => import('./dom-square-icon').then((mod) => mod.DomSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const DzaSquareIcon = dynamicHydrate(() => import('./dza-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const DzaSquareIconSvg = dynamicHydrate(() => import('./dza-square-icon').then((mod) => mod.DzaSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const EcuSquareIcon = dynamicHydrate(() => import('./ecu-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const EcuSquareIconSvg = dynamicHydrate(() => import('./ecu-square-icon').then((mod) => mod.EcuSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const EgySquareIcon = dynamicHydrate(() => import('./egy-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const EgySquareIconSvg = dynamicHydrate(() => import('./egy-square-icon').then((mod) => mod.EgySquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const EriSquareIcon = dynamicHydrate(() => import('./eri-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const EriSquareIconSvg = dynamicHydrate(() => import('./eri-square-icon').then((mod) => mod.EriSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const EshSquareIcon = dynamicHydrate(() => import('./esh-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const EshSquareIconSvg = dynamicHydrate(() => import('./esh-square-icon').then((mod) => mod.EshSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const EspSquareIcon = dynamicHydrate(() => import('./esp-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const EspSquareIconSvg = dynamicHydrate(() => import('./esp-square-icon').then((mod) => mod.EspSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const EstSquareIcon = dynamicHydrate(() => import('./est-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const EstSquareIconSvg = dynamicHydrate(() => import('./est-square-icon').then((mod) => mod.EstSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const EthSquareIcon = dynamicHydrate(() => import('./eth-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const EthSquareIconSvg = dynamicHydrate(() => import('./eth-square-icon').then((mod) => mod.EthSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const EuSquareIcon = dynamicHydrate(() => import('./eu-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const EuSquareIconSvg = dynamicHydrate(() => import('./eu-square-icon').then((mod) => mod.EuSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const FinSquareIcon = dynamicHydrate(() => import('./fin-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const FinSquareIconSvg = dynamicHydrate(() => import('./fin-square-icon').then((mod) => mod.FinSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const FjiSquareIcon = dynamicHydrate(() => import('./fji-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const FjiSquareIconSvg = dynamicHydrate(() => import('./fji-square-icon').then((mod) => mod.FjiSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const FlkSquareIcon = dynamicHydrate(() => import('./flk-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const FlkSquareIconSvg = dynamicHydrate(() => import('./flk-square-icon').then((mod) => mod.FlkSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const FraSquareIcon = dynamicHydrate(() => import('./fra-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const FraSquareIconSvg = dynamicHydrate(() => import('./fra-square-icon').then((mod) => mod.FraSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const FroSquareIcon = dynamicHydrate(() => import('./fro-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const FroSquareIconSvg = dynamicHydrate(() => import('./fro-square-icon').then((mod) => mod.FroSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const FsmSquareIcon = dynamicHydrate(() => import('./fsm-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const FsmSquareIconSvg = dynamicHydrate(() => import('./fsm-square-icon').then((mod) => mod.FsmSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const GabSquareIcon = dynamicHydrate(() => import('./gab-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const GabSquareIconSvg = dynamicHydrate(() => import('./gab-square-icon').then((mod) => mod.GabSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const GbEngSquareIcon = dynamicHydrate(() => import('./gb-eng-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const GbEngSquareIconSvg = dynamicHydrate(
	() => import('./gb-eng-square-icon').then((mod) => mod.GbEngSquareIconSvg),
	{
		loading: function loadingEmptyIcon() {
			return <EmptyIcon />
		},
	}
)
export const GbNirSquareIcon = dynamicHydrate(() => import('./gb-nir-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const GbNirSquareIconSvg = dynamicHydrate(
	() => import('./gb-nir-square-icon').then((mod) => mod.GbNirSquareIconSvg),
	{
		loading: function loadingEmptyIcon() {
			return <EmptyIcon />
		},
	}
)
export const GbSctSquareIcon = dynamicHydrate(() => import('./gb-sct-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const GbSctSquareIconSvg = dynamicHydrate(
	() => import('./gb-sct-square-icon').then((mod) => mod.GbSctSquareIconSvg),
	{
		loading: function loadingEmptyIcon() {
			return <EmptyIcon />
		},
	}
)
export const GbWlsSquareIcon = dynamicHydrate(() => import('./gb-wls-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const GbWlsSquareIconSvg = dynamicHydrate(
	() => import('./gb-wls-square-icon').then((mod) => mod.GbWlsSquareIconSvg),
	{
		loading: function loadingEmptyIcon() {
			return <EmptyIcon />
		},
	}
)
export const GbrSquareIcon = dynamicHydrate(() => import('./gbr-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const GbrSquareIconSvg = dynamicHydrate(() => import('./gbr-square-icon').then((mod) => mod.GbrSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const GeoSquareIcon = dynamicHydrate(() => import('./geo-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const GeoSquareIconSvg = dynamicHydrate(() => import('./geo-square-icon').then((mod) => mod.GeoSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const GgySquareIcon = dynamicHydrate(() => import('./ggy-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const GgySquareIconSvg = dynamicHydrate(() => import('./ggy-square-icon').then((mod) => mod.GgySquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const GhaSquareIcon = dynamicHydrate(() => import('./gha-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const GhaSquareIconSvg = dynamicHydrate(() => import('./gha-square-icon').then((mod) => mod.GhaSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const GibSquareIcon = dynamicHydrate(() => import('./gib-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const GibSquareIconSvg = dynamicHydrate(() => import('./gib-square-icon').then((mod) => mod.GibSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const GinSquareIcon = dynamicHydrate(() => import('./gin-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const GinSquareIconSvg = dynamicHydrate(() => import('./gin-square-icon').then((mod) => mod.GinSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const GmbSquareIcon = dynamicHydrate(() => import('./gmb-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const GmbSquareIconSvg = dynamicHydrate(() => import('./gmb-square-icon').then((mod) => mod.GmbSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const GnbSquareIcon = dynamicHydrate(() => import('./gnb-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const GnbSquareIconSvg = dynamicHydrate(() => import('./gnb-square-icon').then((mod) => mod.GnbSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const GnqSquareIcon = dynamicHydrate(() => import('./gnq-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const GnqSquareIconSvg = dynamicHydrate(() => import('./gnq-square-icon').then((mod) => mod.GnqSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const GrcSquareIcon = dynamicHydrate(() => import('./grc-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const GrcSquareIconSvg = dynamicHydrate(() => import('./grc-square-icon').then((mod) => mod.GrcSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const GrdSquareIcon = dynamicHydrate(() => import('./grd-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const GrdSquareIconSvg = dynamicHydrate(() => import('./grd-square-icon').then((mod) => mod.GrdSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const GrlSquareIcon = dynamicHydrate(() => import('./grl-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const GrlSquareIconSvg = dynamicHydrate(() => import('./grl-square-icon').then((mod) => mod.GrlSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const GtmSquareIcon = dynamicHydrate(() => import('./gtm-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const GtmSquareIconSvg = dynamicHydrate(() => import('./gtm-square-icon').then((mod) => mod.GtmSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const GufSquareIcon = dynamicHydrate(() => import('./guf-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const GufSquareIconSvg = dynamicHydrate(() => import('./guf-square-icon').then((mod) => mod.GufSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const GumSquareIcon = dynamicHydrate(() => import('./gum-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const GumSquareIconSvg = dynamicHydrate(() => import('./gum-square-icon').then((mod) => mod.GumSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const GuySquareIcon = dynamicHydrate(() => import('./guy-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const GuySquareIconSvg = dynamicHydrate(() => import('./guy-square-icon').then((mod) => mod.GuySquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const HkgSquareIcon = dynamicHydrate(() => import('./hkg-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const HkgSquareIconSvg = dynamicHydrate(() => import('./hkg-square-icon').then((mod) => mod.HkgSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const HmdSquareIcon = dynamicHydrate(() => import('./hmd-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const HmdSquareIconSvg = dynamicHydrate(() => import('./hmd-square-icon').then((mod) => mod.HmdSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const HndSquareIcon = dynamicHydrate(() => import('./hnd-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const HndSquareIconSvg = dynamicHydrate(() => import('./hnd-square-icon').then((mod) => mod.HndSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const HrvSquareIcon = dynamicHydrate(() => import('./hrv-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const HrvSquareIconSvg = dynamicHydrate(() => import('./hrv-square-icon').then((mod) => mod.HrvSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const HtiSquareIcon = dynamicHydrate(() => import('./hti-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const HtiSquareIconSvg = dynamicHydrate(() => import('./hti-square-icon').then((mod) => mod.HtiSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const HunSquareIcon = dynamicHydrate(() => import('./hun-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const HunSquareIconSvg = dynamicHydrate(() => import('./hun-square-icon').then((mod) => mod.HunSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const IdnSquareIcon = dynamicHydrate(() => import('./idn-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const IdnSquareIconSvg = dynamicHydrate(() => import('./idn-square-icon').then((mod) => mod.IdnSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const ImnSquareIcon = dynamicHydrate(() => import('./imn-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const ImnSquareIconSvg = dynamicHydrate(() => import('./imn-square-icon').then((mod) => mod.ImnSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const IndSquareIcon = dynamicHydrate(() => import('./ind-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const IndSquareIconSvg = dynamicHydrate(() => import('./ind-square-icon').then((mod) => mod.IndSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const IotSquareIcon = dynamicHydrate(() => import('./iot-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const IotSquareIconSvg = dynamicHydrate(() => import('./iot-square-icon').then((mod) => mod.IotSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const IrlSquareIcon = dynamicHydrate(() => import('./irl-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const IrlSquareIconSvg = dynamicHydrate(() => import('./irl-square-icon').then((mod) => mod.IrlSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const IrnSquareIcon = dynamicHydrate(() => import('./irn-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const IrnSquareIconSvg = dynamicHydrate(() => import('./irn-square-icon').then((mod) => mod.IrnSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const IrqSquareIcon = dynamicHydrate(() => import('./irq-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const IrqSquareIconSvg = dynamicHydrate(() => import('./irq-square-icon').then((mod) => mod.IrqSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const IslSquareIcon = dynamicHydrate(() => import('./isl-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const IslSquareIconSvg = dynamicHydrate(() => import('./isl-square-icon').then((mod) => mod.IslSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const IsrSquareIcon = dynamicHydrate(() => import('./isr-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const IsrSquareIconSvg = dynamicHydrate(() => import('./isr-square-icon').then((mod) => mod.IsrSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const ItaSquareIcon = dynamicHydrate(() => import('./ita-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const ItaSquareIconSvg = dynamicHydrate(() => import('./ita-square-icon').then((mod) => mod.ItaSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const JamSquareIcon = dynamicHydrate(() => import('./jam-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const JamSquareIconSvg = dynamicHydrate(() => import('./jam-square-icon').then((mod) => mod.JamSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const JeySquareIcon = dynamicHydrate(() => import('./jey-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const JeySquareIconSvg = dynamicHydrate(() => import('./jey-square-icon').then((mod) => mod.JeySquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const JorSquareIcon = dynamicHydrate(() => import('./jor-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const JorSquareIconSvg = dynamicHydrate(() => import('./jor-square-icon').then((mod) => mod.JorSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const JpnSquareIcon = dynamicHydrate(() => import('./jpn-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const JpnSquareIconSvg = dynamicHydrate(() => import('./jpn-square-icon').then((mod) => mod.JpnSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const KazSquareIcon = dynamicHydrate(() => import('./kaz-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const KazSquareIconSvg = dynamicHydrate(() => import('./kaz-square-icon').then((mod) => mod.KazSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const KenSquareIcon = dynamicHydrate(() => import('./ken-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const KenSquareIconSvg = dynamicHydrate(() => import('./ken-square-icon').then((mod) => mod.KenSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const KgzSquareIcon = dynamicHydrate(() => import('./kgz-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const KgzSquareIconSvg = dynamicHydrate(() => import('./kgz-square-icon').then((mod) => mod.KgzSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const KhmSquareIcon = dynamicHydrate(() => import('./khm-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const KhmSquareIconSvg = dynamicHydrate(() => import('./khm-square-icon').then((mod) => mod.KhmSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const KirSquareIcon = dynamicHydrate(() => import('./kir-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const KirSquareIconSvg = dynamicHydrate(() => import('./kir-square-icon').then((mod) => mod.KirSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const KnaSquareIcon = dynamicHydrate(() => import('./kna-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const KnaSquareIconSvg = dynamicHydrate(() => import('./kna-square-icon').then((mod) => mod.KnaSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const KorSquareIcon = dynamicHydrate(() => import('./kor-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const KorSquareIconSvg = dynamicHydrate(() => import('./kor-square-icon').then((mod) => mod.KorSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const KwtSquareIcon = dynamicHydrate(() => import('./kwt-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const KwtSquareIconSvg = dynamicHydrate(() => import('./kwt-square-icon').then((mod) => mod.KwtSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const LaoSquareIcon = dynamicHydrate(() => import('./lao-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const LaoSquareIconSvg = dynamicHydrate(() => import('./lao-square-icon').then((mod) => mod.LaoSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const LbnSquareIcon = dynamicHydrate(() => import('./lbn-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const LbnSquareIconSvg = dynamicHydrate(() => import('./lbn-square-icon').then((mod) => mod.LbnSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const LbrSquareIcon = dynamicHydrate(() => import('./lbr-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const LbrSquareIconSvg = dynamicHydrate(() => import('./lbr-square-icon').then((mod) => mod.LbrSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const LbySquareIcon = dynamicHydrate(() => import('./lby-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const LbySquareIconSvg = dynamicHydrate(() => import('./lby-square-icon').then((mod) => mod.LbySquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const LcaSquareIcon = dynamicHydrate(() => import('./lca-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const LcaSquareIconSvg = dynamicHydrate(() => import('./lca-square-icon').then((mod) => mod.LcaSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const LieSquareIcon = dynamicHydrate(() => import('./lie-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const LieSquareIconSvg = dynamicHydrate(() => import('./lie-square-icon').then((mod) => mod.LieSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const LkaSquareIcon = dynamicHydrate(() => import('./lka-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const LkaSquareIconSvg = dynamicHydrate(() => import('./lka-square-icon').then((mod) => mod.LkaSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const LsoSquareIcon = dynamicHydrate(() => import('./lso-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const LsoSquareIconSvg = dynamicHydrate(() => import('./lso-square-icon').then((mod) => mod.LsoSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const LtuSquareIcon = dynamicHydrate(() => import('./ltu-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const LtuSquareIconSvg = dynamicHydrate(() => import('./ltu-square-icon').then((mod) => mod.LtuSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const LuxSquareIcon = dynamicHydrate(() => import('./lux-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const LuxSquareIconSvg = dynamicHydrate(() => import('./lux-square-icon').then((mod) => mod.LuxSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const LvaSquareIcon = dynamicHydrate(() => import('./lva-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const LvaSquareIconSvg = dynamicHydrate(() => import('./lva-square-icon').then((mod) => mod.LvaSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const MacSquareIcon = dynamicHydrate(() => import('./mac-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const MacSquareIconSvg = dynamicHydrate(() => import('./mac-square-icon').then((mod) => mod.MacSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const MafSquareIcon = dynamicHydrate(() => import('./maf-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const MafSquareIconSvg = dynamicHydrate(() => import('./maf-square-icon').then((mod) => mod.MafSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const MarSquareIcon = dynamicHydrate(() => import('./mar-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const MarSquareIconSvg = dynamicHydrate(() => import('./mar-square-icon').then((mod) => mod.MarSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const McoSquareIcon = dynamicHydrate(() => import('./mco-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const McoSquareIconSvg = dynamicHydrate(() => import('./mco-square-icon').then((mod) => mod.McoSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const MdaSquareIcon = dynamicHydrate(() => import('./mda-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const MdaSquareIconSvg = dynamicHydrate(() => import('./mda-square-icon').then((mod) => mod.MdaSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const MdgSquareIcon = dynamicHydrate(() => import('./mdg-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const MdgSquareIconSvg = dynamicHydrate(() => import('./mdg-square-icon').then((mod) => mod.MdgSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const MdvSquareIcon = dynamicHydrate(() => import('./mdv-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const MdvSquareIconSvg = dynamicHydrate(() => import('./mdv-square-icon').then((mod) => mod.MdvSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const MexSquareIcon = dynamicHydrate(() => import('./mex-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const MexSquareIconSvg = dynamicHydrate(() => import('./mex-square-icon').then((mod) => mod.MexSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const MhlSquareIcon = dynamicHydrate(() => import('./mhl-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const MhlSquareIconSvg = dynamicHydrate(() => import('./mhl-square-icon').then((mod) => mod.MhlSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const MkdSquareIcon = dynamicHydrate(() => import('./mkd-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const MkdSquareIconSvg = dynamicHydrate(() => import('./mkd-square-icon').then((mod) => mod.MkdSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const MliSquareIcon = dynamicHydrate(() => import('./mli-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const MliSquareIconSvg = dynamicHydrate(() => import('./mli-square-icon').then((mod) => mod.MliSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const MltSquareIcon = dynamicHydrate(() => import('./mlt-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const MltSquareIconSvg = dynamicHydrate(() => import('./mlt-square-icon').then((mod) => mod.MltSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const MmrSquareIcon = dynamicHydrate(() => import('./mmr-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const MmrSquareIconSvg = dynamicHydrate(() => import('./mmr-square-icon').then((mod) => mod.MmrSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const MneSquareIcon = dynamicHydrate(() => import('./mne-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const MneSquareIconSvg = dynamicHydrate(() => import('./mne-square-icon').then((mod) => mod.MneSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const MngSquareIcon = dynamicHydrate(() => import('./mng-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const MngSquareIconSvg = dynamicHydrate(() => import('./mng-square-icon').then((mod) => mod.MngSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const MnpSquareIcon = dynamicHydrate(() => import('./mnp-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const MnpSquareIconSvg = dynamicHydrate(() => import('./mnp-square-icon').then((mod) => mod.MnpSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const MozSquareIcon = dynamicHydrate(() => import('./moz-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const MozSquareIconSvg = dynamicHydrate(() => import('./moz-square-icon').then((mod) => mod.MozSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const MrtSquareIcon = dynamicHydrate(() => import('./mrt-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const MrtSquareIconSvg = dynamicHydrate(() => import('./mrt-square-icon').then((mod) => mod.MrtSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const MsrSquareIcon = dynamicHydrate(() => import('./msr-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const MsrSquareIconSvg = dynamicHydrate(() => import('./msr-square-icon').then((mod) => mod.MsrSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const MtqSquareIcon = dynamicHydrate(() => import('./mtq-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const MtqSquareIconSvg = dynamicHydrate(() => import('./mtq-square-icon').then((mod) => mod.MtqSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const MusSquareIcon = dynamicHydrate(() => import('./mus-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const MusSquareIconSvg = dynamicHydrate(() => import('./mus-square-icon').then((mod) => mod.MusSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const MwiSquareIcon = dynamicHydrate(() => import('./mwi-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const MwiSquareIconSvg = dynamicHydrate(() => import('./mwi-square-icon').then((mod) => mod.MwiSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const MysSquareIcon = dynamicHydrate(() => import('./mys-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const MysSquareIconSvg = dynamicHydrate(() => import('./mys-square-icon').then((mod) => mod.MysSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const MytSquareIcon = dynamicHydrate(() => import('./myt-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const MytSquareIconSvg = dynamicHydrate(() => import('./myt-square-icon').then((mod) => mod.MytSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const NamSquareIcon = dynamicHydrate(() => import('./nam-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const NamSquareIconSvg = dynamicHydrate(() => import('./nam-square-icon').then((mod) => mod.NamSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const NclSquareIcon = dynamicHydrate(() => import('./ncl-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const NclSquareIconSvg = dynamicHydrate(() => import('./ncl-square-icon').then((mod) => mod.NclSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const NcySquareIcon = dynamicHydrate(() => import('./ncy-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const NcySquareIconSvg = dynamicHydrate(() => import('./ncy-square-icon').then((mod) => mod.NcySquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const NerSquareIcon = dynamicHydrate(() => import('./ner-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const NerSquareIconSvg = dynamicHydrate(() => import('./ner-square-icon').then((mod) => mod.NerSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const NfkSquareIcon = dynamicHydrate(() => import('./nfk-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const NfkSquareIconSvg = dynamicHydrate(() => import('./nfk-square-icon').then((mod) => mod.NfkSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const NgaSquareIcon = dynamicHydrate(() => import('./nga-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const NgaSquareIconSvg = dynamicHydrate(() => import('./nga-square-icon').then((mod) => mod.NgaSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const NicSquareIcon = dynamicHydrate(() => import('./nic-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const NicSquareIconSvg = dynamicHydrate(() => import('./nic-square-icon').then((mod) => mod.NicSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const NiuSquareIcon = dynamicHydrate(() => import('./niu-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const NiuSquareIconSvg = dynamicHydrate(() => import('./niu-square-icon').then((mod) => mod.NiuSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const NldSquareIcon = dynamicHydrate(() => import('./nld-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const NldSquareIconSvg = dynamicHydrate(() => import('./nld-square-icon').then((mod) => mod.NldSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const NorSquareIcon = dynamicHydrate(() => import('./nor-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const NorSquareIconSvg = dynamicHydrate(() => import('./nor-square-icon').then((mod) => mod.NorSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const NplSquareIcon = dynamicHydrate(() => import('./npl-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const NplSquareIconSvg = dynamicHydrate(() => import('./npl-square-icon').then((mod) => mod.NplSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const NruSquareIcon = dynamicHydrate(() => import('./nru-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const NruSquareIconSvg = dynamicHydrate(() => import('./nru-square-icon').then((mod) => mod.NruSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const NzlSquareIcon = dynamicHydrate(() => import('./nzl-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const NzlSquareIconSvg = dynamicHydrate(() => import('./nzl-square-icon').then((mod) => mod.NzlSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const OmnSquareIcon = dynamicHydrate(() => import('./omn-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const OmnSquareIconSvg = dynamicHydrate(() => import('./omn-square-icon').then((mod) => mod.OmnSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const PakSquareIcon = dynamicHydrate(() => import('./pak-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const PakSquareIconSvg = dynamicHydrate(() => import('./pak-square-icon').then((mod) => mod.PakSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const PanSquareIcon = dynamicHydrate(() => import('./pan-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const PanSquareIconSvg = dynamicHydrate(() => import('./pan-square-icon').then((mod) => mod.PanSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const PcnSquareIcon = dynamicHydrate(() => import('./pcn-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const PcnSquareIconSvg = dynamicHydrate(() => import('./pcn-square-icon').then((mod) => mod.PcnSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const PerSquareIcon = dynamicHydrate(() => import('./per-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const PerSquareIconSvg = dynamicHydrate(() => import('./per-square-icon').then((mod) => mod.PerSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const PhlSquareIcon = dynamicHydrate(() => import('./phl-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const PhlSquareIconSvg = dynamicHydrate(() => import('./phl-square-icon').then((mod) => mod.PhlSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const PlwSquareIcon = dynamicHydrate(() => import('./plw-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const PlwSquareIconSvg = dynamicHydrate(() => import('./plw-square-icon').then((mod) => mod.PlwSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const PngSquareIcon = dynamicHydrate(() => import('./png-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const PngSquareIconSvg = dynamicHydrate(() => import('./png-square-icon').then((mod) => mod.PngSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const PolSquareIcon = dynamicHydrate(() => import('./pol-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const PolSquareIconSvg = dynamicHydrate(() => import('./pol-square-icon').then((mod) => mod.PolSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const PriSquareIcon = dynamicHydrate(() => import('./pri-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const PriSquareIconSvg = dynamicHydrate(() => import('./pri-square-icon').then((mod) => mod.PriSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const PrkSquareIcon = dynamicHydrate(() => import('./prk-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const PrkSquareIconSvg = dynamicHydrate(() => import('./prk-square-icon').then((mod) => mod.PrkSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const PrtSquareIcon = dynamicHydrate(() => import('./prt-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const PrtSquareIconSvg = dynamicHydrate(() => import('./prt-square-icon').then((mod) => mod.PrtSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const PrySquareIcon = dynamicHydrate(() => import('./pry-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const PrySquareIconSvg = dynamicHydrate(() => import('./pry-square-icon').then((mod) => mod.PrySquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const PseSquareIcon = dynamicHydrate(() => import('./pse-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const PseSquareIconSvg = dynamicHydrate(() => import('./pse-square-icon').then((mod) => mod.PseSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const PyfSquareIcon = dynamicHydrate(() => import('./pyf-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const PyfSquareIconSvg = dynamicHydrate(() => import('./pyf-square-icon').then((mod) => mod.PyfSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const QatSquareIcon = dynamicHydrate(() => import('./qat-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const QatSquareIconSvg = dynamicHydrate(() => import('./qat-square-icon').then((mod) => mod.QatSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const ReuSquareIcon = dynamicHydrate(() => import('./reu-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const ReuSquareIconSvg = dynamicHydrate(() => import('./reu-square-icon').then((mod) => mod.ReuSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const RouSquareIcon = dynamicHydrate(() => import('./rou-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const RouSquareIconSvg = dynamicHydrate(() => import('./rou-square-icon').then((mod) => mod.RouSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const RusSquareIcon = dynamicHydrate(() => import('./rus-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const RusSquareIconSvg = dynamicHydrate(() => import('./rus-square-icon').then((mod) => mod.RusSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const RwaSquareIcon = dynamicHydrate(() => import('./rwa-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const RwaSquareIconSvg = dynamicHydrate(() => import('./rwa-square-icon').then((mod) => mod.RwaSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const SauSquareIcon = dynamicHydrate(() => import('./sau-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const SauSquareIconSvg = dynamicHydrate(() => import('./sau-square-icon').then((mod) => mod.SauSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const SdnSquareIcon = dynamicHydrate(() => import('./sdn-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const SdnSquareIconSvg = dynamicHydrate(() => import('./sdn-square-icon').then((mod) => mod.SdnSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const SenSquareIcon = dynamicHydrate(() => import('./sen-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const SenSquareIconSvg = dynamicHydrate(() => import('./sen-square-icon').then((mod) => mod.SenSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const SgpSquareIcon = dynamicHydrate(() => import('./sgp-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const SgpSquareIconSvg = dynamicHydrate(() => import('./sgp-square-icon').then((mod) => mod.SgpSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const SgsSquareIcon = dynamicHydrate(() => import('./sgs-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const SgsSquareIconSvg = dynamicHydrate(() => import('./sgs-square-icon').then((mod) => mod.SgsSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const ShnSquareIcon = dynamicHydrate(() => import('./shn-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const ShnSquareIconSvg = dynamicHydrate(() => import('./shn-square-icon').then((mod) => mod.ShnSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const SjmSquareIcon = dynamicHydrate(() => import('./sjm-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const SjmSquareIconSvg = dynamicHydrate(() => import('./sjm-square-icon').then((mod) => mod.SjmSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const SlbSquareIcon = dynamicHydrate(() => import('./slb-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const SlbSquareIconSvg = dynamicHydrate(() => import('./slb-square-icon').then((mod) => mod.SlbSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const SleSquareIcon = dynamicHydrate(() => import('./sle-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const SleSquareIconSvg = dynamicHydrate(() => import('./sle-square-icon').then((mod) => mod.SleSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const SlvSquareIcon = dynamicHydrate(() => import('./slv-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const SlvSquareIconSvg = dynamicHydrate(() => import('./slv-square-icon').then((mod) => mod.SlvSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const SmrSquareIcon = dynamicHydrate(() => import('./smr-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const SmrSquareIconSvg = dynamicHydrate(() => import('./smr-square-icon').then((mod) => mod.SmrSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const SomSquareIcon = dynamicHydrate(() => import('./som-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const SomSquareIconSvg = dynamicHydrate(() => import('./som-square-icon').then((mod) => mod.SomSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const SpmSquareIcon = dynamicHydrate(() => import('./spm-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const SpmSquareIconSvg = dynamicHydrate(() => import('./spm-square-icon').then((mod) => mod.SpmSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const SrbSquareIcon = dynamicHydrate(() => import('./srb-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const SrbSquareIconSvg = dynamicHydrate(() => import('./srb-square-icon').then((mod) => mod.SrbSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const SsdSquareIcon = dynamicHydrate(() => import('./ssd-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const SsdSquareIconSvg = dynamicHydrate(() => import('./ssd-square-icon').then((mod) => mod.SsdSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const StpSquareIcon = dynamicHydrate(() => import('./stp-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const StpSquareIconSvg = dynamicHydrate(() => import('./stp-square-icon').then((mod) => mod.StpSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const SurSquareIcon = dynamicHydrate(() => import('./sur-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const SurSquareIconSvg = dynamicHydrate(() => import('./sur-square-icon').then((mod) => mod.SurSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const SvkSquareIcon = dynamicHydrate(() => import('./svk-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const SvkSquareIconSvg = dynamicHydrate(() => import('./svk-square-icon').then((mod) => mod.SvkSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const SvnSquareIcon = dynamicHydrate(() => import('./svn-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const SvnSquareIconSvg = dynamicHydrate(() => import('./svn-square-icon').then((mod) => mod.SvnSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const SweSquareIcon = dynamicHydrate(() => import('./swe-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const SweSquareIconSvg = dynamicHydrate(() => import('./swe-square-icon').then((mod) => mod.SweSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const SwzSquareIcon = dynamicHydrate(() => import('./swz-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const SwzSquareIconSvg = dynamicHydrate(() => import('./swz-square-icon').then((mod) => mod.SwzSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const SxmSquareIcon = dynamicHydrate(() => import('./sxm-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const SxmSquareIconSvg = dynamicHydrate(() => import('./sxm-square-icon').then((mod) => mod.SxmSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const SycSquareIcon = dynamicHydrate(() => import('./syc-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const SycSquareIconSvg = dynamicHydrate(() => import('./syc-square-icon').then((mod) => mod.SycSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const SyrSquareIcon = dynamicHydrate(() => import('./syr-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const SyrSquareIconSvg = dynamicHydrate(() => import('./syr-square-icon').then((mod) => mod.SyrSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const TcaSquareIcon = dynamicHydrate(() => import('./tca-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const TcaSquareIconSvg = dynamicHydrate(() => import('./tca-square-icon').then((mod) => mod.TcaSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const TcdSquareIcon = dynamicHydrate(() => import('./tcd-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const TcdSquareIconSvg = dynamicHydrate(() => import('./tcd-square-icon').then((mod) => mod.TcdSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const TgoSquareIcon = dynamicHydrate(() => import('./tgo-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const TgoSquareIconSvg = dynamicHydrate(() => import('./tgo-square-icon').then((mod) => mod.TgoSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const ThaSquareIcon = dynamicHydrate(() => import('./tha-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const ThaSquareIconSvg = dynamicHydrate(() => import('./tha-square-icon').then((mod) => mod.ThaSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const TjkSquareIcon = dynamicHydrate(() => import('./tjk-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const TjkSquareIconSvg = dynamicHydrate(() => import('./tjk-square-icon').then((mod) => mod.TjkSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const TklSquareIcon = dynamicHydrate(() => import('./tkl-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const TklSquareIconSvg = dynamicHydrate(() => import('./tkl-square-icon').then((mod) => mod.TklSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const TkmSquareIcon = dynamicHydrate(() => import('./tkm-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const TkmSquareIconSvg = dynamicHydrate(() => import('./tkm-square-icon').then((mod) => mod.TkmSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const TlsSquareIcon = dynamicHydrate(() => import('./tls-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const TlsSquareIconSvg = dynamicHydrate(() => import('./tls-square-icon').then((mod) => mod.TlsSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const TonSquareIcon = dynamicHydrate(() => import('./ton-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const TonSquareIconSvg = dynamicHydrate(() => import('./ton-square-icon').then((mod) => mod.TonSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const TraSquareIcon = dynamicHydrate(() => import('./tra-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const TraSquareIconSvg = dynamicHydrate(() => import('./tra-square-icon').then((mod) => mod.TraSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const TtoSquareIcon = dynamicHydrate(() => import('./tto-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const TtoSquareIconSvg = dynamicHydrate(() => import('./tto-square-icon').then((mod) => mod.TtoSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const TunSquareIcon = dynamicHydrate(() => import('./tun-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const TunSquareIconSvg = dynamicHydrate(() => import('./tun-square-icon').then((mod) => mod.TunSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const TurSquareIcon = dynamicHydrate(() => import('./tur-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const TurSquareIconSvg = dynamicHydrate(() => import('./tur-square-icon').then((mod) => mod.TurSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const TuvSquareIcon = dynamicHydrate(() => import('./tuv-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const TuvSquareIconSvg = dynamicHydrate(() => import('./tuv-square-icon').then((mod) => mod.TuvSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const TwnSquareIcon = dynamicHydrate(() => import('./twn-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const TwnSquareIconSvg = dynamicHydrate(() => import('./twn-square-icon').then((mod) => mod.TwnSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const TzaSquareIcon = dynamicHydrate(() => import('./tza-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const TzaSquareIconSvg = dynamicHydrate(() => import('./tza-square-icon').then((mod) => mod.TzaSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const UgaSquareIcon = dynamicHydrate(() => import('./uga-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const UgaSquareIconSvg = dynamicHydrate(() => import('./uga-square-icon').then((mod) => mod.UgaSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const UkrSquareIcon = dynamicHydrate(() => import('./ukr-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const UkrSquareIconSvg = dynamicHydrate(() => import('./ukr-square-icon').then((mod) => mod.UkrSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const UmiSquareIcon = dynamicHydrate(() => import('./umi-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const UmiSquareIconSvg = dynamicHydrate(() => import('./umi-square-icon').then((mod) => mod.UmiSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const UnSquareIcon = dynamicHydrate(() => import('./un-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const UnSquareIconSvg = dynamicHydrate(() => import('./un-square-icon').then((mod) => mod.UnSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const UrySquareIcon = dynamicHydrate(() => import('./ury-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const UrySquareIconSvg = dynamicHydrate(() => import('./ury-square-icon').then((mod) => mod.UrySquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const UsaSquareIcon = dynamicHydrate(() => import('./usa-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const UsaSquareIconSvg = dynamicHydrate(() => import('./usa-square-icon').then((mod) => mod.UsaSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const UzbSquareIcon = dynamicHydrate(() => import('./uzb-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const UzbSquareIconSvg = dynamicHydrate(() => import('./uzb-square-icon').then((mod) => mod.UzbSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const VatSquareIcon = dynamicHydrate(() => import('./vat-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const VatSquareIconSvg = dynamicHydrate(() => import('./vat-square-icon').then((mod) => mod.VatSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const VctSquareIcon = dynamicHydrate(() => import('./vct-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const VctSquareIconSvg = dynamicHydrate(() => import('./vct-square-icon').then((mod) => mod.VctSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const VenSquareIcon = dynamicHydrate(() => import('./ven-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const VenSquareIconSvg = dynamicHydrate(() => import('./ven-square-icon').then((mod) => mod.VenSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const VgbSquareIcon = dynamicHydrate(() => import('./vgb-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const VgbSquareIconSvg = dynamicHydrate(() => import('./vgb-square-icon').then((mod) => mod.VgbSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const VirSquareIcon = dynamicHydrate(() => import('./vir-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const VirSquareIconSvg = dynamicHydrate(() => import('./vir-square-icon').then((mod) => mod.VirSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const VnmSquareIcon = dynamicHydrate(() => import('./vnm-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const VnmSquareIconSvg = dynamicHydrate(() => import('./vnm-square-icon').then((mod) => mod.VnmSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const VutSquareIcon = dynamicHydrate(() => import('./vut-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const VutSquareIconSvg = dynamicHydrate(() => import('./vut-square-icon').then((mod) => mod.VutSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const WlfSquareIcon = dynamicHydrate(() => import('./wlf-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const WlfSquareIconSvg = dynamicHydrate(() => import('./wlf-square-icon').then((mod) => mod.WlfSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const WorldSquareIcon = dynamicHydrate(() => import('./world-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const WorldSquareIconSvg = dynamicHydrate(
	() => import('./world-square-icon').then((mod) => mod.WorldSquareIconSvg),
	{
		loading: function loadingEmptyIcon() {
			return <EmptyIcon />
		},
	}
)
export const WsmSquareIcon = dynamicHydrate(() => import('./wsm-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const WsmSquareIconSvg = dynamicHydrate(() => import('./wsm-square-icon').then((mod) => mod.WsmSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const XkxSquareIcon = dynamicHydrate(() => import('./xkx-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const XkxSquareIconSvg = dynamicHydrate(() => import('./xkx-square-icon').then((mod) => mod.XkxSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const YemSquareIcon = dynamicHydrate(() => import('./yem-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const YemSquareIconSvg = dynamicHydrate(() => import('./yem-square-icon').then((mod) => mod.YemSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const ZafSquareIcon = dynamicHydrate(() => import('./zaf-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const ZafSquareIconSvg = dynamicHydrate(() => import('./zaf-square-icon').then((mod) => mod.ZafSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const ZmbSquareIcon = dynamicHydrate(() => import('./zmb-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const ZmbSquareIconSvg = dynamicHydrate(() => import('./zmb-square-icon').then((mod) => mod.ZmbSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const ZweSquareIcon = dynamicHydrate(() => import('./zwe-square-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const ZweSquareIconSvg = dynamicHydrate(() => import('./zwe-square-icon').then((mod) => mod.ZweSquareIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
